import { useState } from 'react';
import { apiPost } from '../config/api';
import { useAuth } from '../contexts/AuthContext';

export default function ChangePasswordScreen() {
  const { setMustChangePassword } = useAuth();
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');

  const submit = async (event) => {
    event.preventDefault();
    setError('');
    try {
      await apiPost('/api/nurse/change-password', {
        new_password: newPassword,
        confirm_password: confirmPassword,
      });
      setMustChangePassword(false);
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-white px-4">
      <form onSubmit={submit} className="w-full max-w-md space-y-4 rounded-2xl border p-8 shadow-card">
        <h1 className="text-xl font-bold">You must change your password before continuing.</h1>
        {error && <p className="text-sm text-red-700">{error}</p>}
        <input
          type="password"
          minLength={8}
          className="w-full rounded-xl border px-3 py-3"
          placeholder="New password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          required
        />
        <input
          type="password"
          minLength={8}
          className="w-full rounded-xl border px-3 py-3"
          placeholder="Confirm password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
        />
        <button className="btn-primary" type="submit">Save and continue</button>
      </form>
    </div>
  );
}
